export class CommonTexts {
// eslint-disable-next-line sonarjs/public-static-readonly
    static texts = {
        save: "Spara",
        cancel: "Avbryt",
        delete: "Ta bort",
        confirmDeleteText: "Är du säker på att du vill ta bort?",
        add: "Lägg till",
        yes: "Ja",
        no: "Nej",
        clear: "Rensa",
        undoChanges: "Ångra ändringar"
    };
}
